/**
 * SectionHeader
 *
 * Used in editors to define sections.
 */

import { classNames } from "./utils/classNames";

export const SectionHeader = ({
  title,
  actionsTray,
  className,
  actionsVisibleOnHover,
  showBackgroundOnHover,
}: {
  title: string | React.ReactNode;
  /** Actions to display on the right side of the header */
  actionsTray?: React.ReactNode;
  className?: string;
  /** Show actions on hover */
  actionsVisibleOnHover?: boolean;
  /** Show the background on hover */
  showBackgroundOnHover?: boolean;
}) => {
  return (
    <div className={classNames("group/section-header relative my-6 flex h-24 items-center", className)}>
      {/* This background expands beyond the the 24px box as a hover effect */}
      <div
        className={classNames(
          "absolute -bottom-6 -left-[10px] -right-[10px] -top-6 rounded-ms transition-all duration-300",
          showBackgroundOnHover ? "group-hover/section-header:bg-background-base-3" : "",
        )}
      ></div>
      <div className={classNames("relative flex w-full items-center justify-between py-2")}>
        <h3 className={classNames("my-auto text-12-12 font-medium")}>{title}</h3>
        {actionsTray && (
          <div
            className={classNames(
              "flex h-full items-center gap-x-8 transition-opacity",
              actionsVisibleOnHover ? "opacity-0 group-hover:opacity-100" : "opacity-100",
              "has-[[data-state=open]]:opacity-100",
            )}
          >
            {actionsTray}
          </div>
        )}
      </div>
    </div>
  );
};
